var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconQuote = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-4.375 -4.375)" },
                React.createElement("path", { d: "M15.9,9.9h-3.8c-1.6,0-2.8,1.3-2.8,2.8v7.5c0,1.6,1.3,2.8,2.8,2.8h2.3c0.3,0,0.5,0.2,0.5,0.5\n\t\tc0,0,0,0,0,0c-0.1,1.6-0.8,3.2-1.8,4.4c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.3,0.1h2.4c0.1,0,0.3-0.1,0.4-0.2\n\t\tc1.1-1.6,1.7-3.6,1.7-5.5V11.8C17.8,10.8,17,10,15.9,9.9C16,9.9,15.9,9.9,15.9,9.9L15.9,9.9z" }),
                React.createElement("path", { d: "M27.7,9.9h-3.8c-1.6,0-2.8,1.3-2.8,2.8v7.5c0,1.6,1.3,2.8,2.8,2.8h2.3c0.3,0,0.5,0.2,0.5,0.5\n\t\tc0,0,0,0,0,0c-0.1,1.6-0.8,3.2-1.8,4.4c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.3,0.1h2.4c0.1,0,0.3-0.1,0.4-0.2\n\t\tc1.1-1.6,1.7-3.6,1.7-5.5V11.8C29.5,10.8,28.8,10,27.7,9.9C27.7,9.9,27.7,9.9,27.7,9.9z" })))));
});
export default IconQuote;
//# sourceMappingURL=IconQuote.js.map